// components/GlobalStyles.js
import React from 'react';

const GlobalStyles = () => {
  return (
    <style>
      {`
        .hero-gradient {
          background: linear-gradient(135deg, #1a1a1a 0%, #6b21a8 50%, #9333ea 100%);
        }
        
        .support-card {
          transition: all 0.3s ease;
          background: linear-gradient(145deg, #1f2937, #111827);
        }
        
        .support-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px -12px rgba(139, 92, 246, 0.3);
        }
        
        .support-card.active {
          border: 2px solid #9333ea;
          background: linear-gradient(145deg, #312e81, #1e1b4b);
        }
        
        .chat-container {
          height: 400px;
          overflow-y: auto;
        }
        
        .message-user {
          background: linear-gradient(135deg, #6b21a8, #9333ea);
        }
        
        .message-bot {
          background: linear-gradient(145deg, #374151, #1f2937);
        }
        
        .status-online {
          width: 8px;
          height: 8px;
          background: #10b981;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        
        .faq-card {
          transition: all 0.3s ease;
        }
        
        .faq-card:hover {
          background: rgba(139, 92, 246, 0.1);
        }
        
        .floating-support {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background: linear-gradient(135deg, #6b21a8, #9333ea);
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 30px -10px rgba(139, 92, 246, 0.5);
          animation: bounce 2s infinite;
          z-index: 1000;
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
      `}
    </style>
  );
};

export default GlobalStyles;